import localization from 'moment/locale/vi'

// 2 func phục vụ cho việc chuyển múi giờ của moment
export const getLocale = () => 'vi'

export const getLocalization = () => localization
